import { Loader } from './Loader';
import { ILoader } from './Loader.interfaces';

export default Loader;
export { Loader, ILoader };
